import { Box, Flex, Spinner, Text } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { getMonthlyReportPivotRtClients } from "../../../Http/Index"
import { PivotTable } from "./PivotTable"

interface Props {
  selectedMonth: string
  selectedCompanyId?: string
}

export const RtClients: React.FC<Props> = ({
  selectedMonth,
  selectedCompanyId = "",
}) => {
  const [data, setData] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonth, selectedCompanyId])

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const params: Record<string, any> = {}
      if (selectedCompanyId) params.companyId = selectedCompanyId
      const res = await getMonthlyReportPivotRtClients(selectedMonth, params)
      setData(res.data?.data || [])
    } catch {
    } finally {
      setIsLoading(false)
    }
  }

  const quarters = data
    .flatMap((item: any) => (item.quarters || []).map((q: any) => q.quarter))
    .filter((v, i, a) => v && a.indexOf(v) === i)

  const rows = data.map((item: any) => ({
    rowLabel: item._id,
    values: Object.fromEntries(
      (item.quarters || []).map((q: any) => [q.quarter, q.count])
    ),
    total: item.total,
  }))

  return (
    <Box mt={2}>
      {isLoading ? (
        <Flex justify="center" py={10}><Spinner /></Flex>
      ) : rows.length === 0 ? (
        <Text color="gray.400" textAlign="center" py={6}>No data</Text>
      ) : (
        <PivotTable rows={rows} columns={quarters} />
      )}
    </Box>
  )
}
